import { Routes } from '@angular/router'
import { IsAuthentificated } from '../core/guards/autentification'

export const routes: Routes = [
  {
    path: 'oidc/callback',
    loadComponent: () => import('./oidc-callback/oidc-callback.component').then((c) => c.OidcCallbackComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then((c) => c.Layout),
    canActivate: [IsAuthentificated],
    children: [
      {
        path: '',
        loadComponent: () => import('./dashboard/dashboard.component').then((c) => c.Dashboard),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((c) => c.Login),
  },
]
